

export default {
  name: "ImageModal",
  computed: {
    humanReadableSourceCopyright() {
      try {
        if (this.$attrs.source) {
          return `${new URL(this.$attrs.source).origin}`
        }
      } catch {
      }

      return ''
    },
  }
}
